import request from '@/router/axios'

export const getList = (current, size, params) => request({
  url: '/api/blade-system/dict/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getParentList = (current, size, params) => request({
  url: '/api/blade-system/dict/parent-list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getChildList = (current, size, parentId, params) => request({
  url: '/api/blade-system/dict/child-list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    parentId,
  },
})

export const remove = ids => request({
  url: '/api/blade-system/dict/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-system/dict/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-system/dict/submit',
  method: 'post',
  data: row,
})

export const getDict = id => request({
  url: '/api/blade-system/dict/detail',
  method: 'get',
  params: {
    id,
  },
})
export const getDictTree = () => request({
  url: '/api/blade-system/dict/tree?code=DICT',
  method: 'get',
})

export const getDictionary = params => request({
  url: '/api/blade-system/dict/dictionary',
  method: 'get',
  params,
})

export const getDictionaryByBiz = params => request({
  url: '/api/blade-system/dict-biz/dictionary',
  method: 'get',
  params,
})

export const getBizList = (current, size, params) => request({
  url: '/api/blade-system/dict-biz/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
